// One-time terms + privacy agreement. The API is the gate: any authenticated
// route answers 403 { code: "terms_required" } until POST /auth/accept-terms
// records the server time. The web app shows AcceptTermsPage for that user.

export const TERMS_URL = "https://www.brxs.ca/terms";
export const PRIVACY_URL = "https://www.brxs.ca/privacy";
export const TERMS_REQUIRED_CODE = "terms_required";
export const TERMS_REQUIRED_EVENT = "bricks:terms-required";

/** True when an axios error is the API's terms gate. */
export function isTermsRequiredError(error) {
  const res = error?.response;
  return res?.status === 403 && res?.data?.detail?.code === TERMS_REQUIRED_CODE;
}

/** Profile from /auth/me (or a cached copy) still needs the agreement step. */
export function needsTerms(user) {
  return !!user && !user.needs_email && user.needs_terms === true;
}
